var map = {
	"./Aleksandr.png": [
		423
	],
	"./Artem.webp": [
		167
	],
	"./Dmitrii.webp": [
		814
	],
	"./Evgeniy.webp": [
		517
	],
	"./Lily.png": [
		364,
		364
	],
	"./Rim.webp": [
		592
	],
	"./arcade_packaging.png": [
		412,
		412
	],
	"./bde_mobile.png": [
		904,
		904
	],
	"./bus_products.png": [
		489,
		489
	],
	"./bus_solutions.png": [
		673,
		673
	],
	"./business_packaging.png": [
		310,
		310
	],
	"./event_management.png": [
		821,
		202
	],
	"./gambling.png": [
		669,
		669
	],
	"./gambling_packaging.png": [
		9,
		9
	],
	"./indie_2d.png": [
		546,
		546
	],
	"./mobile_games.png": [
		986,
		986
	],
	"./screen_administration.png": [
		831,
		831
	],
	"./todo_app.png": [
		940,
		940
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 80;
module.exports = webpackAsyncContext;